import { Component, Input } from '@angular/core';

@Component({
  selector: 'toggled-html-content',
  templateUrl: './toggled-html-content.component.html',
  styleUrls: ['./toggled-html-content.component.scss'],
  standalone: false

})
export class ToggledHtmlContentComponent {
  @Input() content: string = '';
  @Input() showMenu: boolean = false;

  constructor() {}

}
